import MerchendiseEditorSection from "../components/merchandise/manager/editorSection";
import { Hero } from "../layouts/hero";
import { MainLayout } from "../layouts/mainLayout";

function MerchendiseManager() {
  return (
    <MainLayout>
      <div className="main">
        <Hero
          title="Merchandise Management"
          logo={false}
          desc="Create, update, organize, and manage your merchandise catalog"
        />
        <MerchendiseEditorSection />
      </div>
    </MainLayout>
  );
}

export default MerchendiseManager;
